import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import MissingPrerequisiteStepActionPicker
  from 'Context/IdentityChallengeContext/ViewPicker/Dialog/Steps/MissingPrerequisiteStep/Layout/MissingPrerequisiteStepActionPicker';
import { navigateToClientPage } from 'Views/Page/Content/Templates';
import {
  FDDialogActions, FDDialogContent, FDStack, FDTextButton,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutVertical from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutVertical';


function MissingPrerequisiteLayout() {
  const { resource } = useMetaLayoutContext();
  const { handleClose } = useIdentityChallengeContext();

  const handleContinueToSecuritySettings = () => {
    navigateToClientPage(resource.relationship(fr.relationships.settingsSectionSecurity.name).link('related'));
    handleClose();
  };

  return (
    <>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'stretch'} spacing={2} test={'dicrs-missing-prereqs-layout'}>
          <MetaControlField attr={'primaryText'} />
          <MetaControlField attr={'secondaryText'} />
          <MetaLayoutVertical resource={resource} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDTextButton
          label={'Contact Support'}
          test={'dicrs-missing-prereqs-contact-support-button'}
          href={`mailto:${resource.attr('contactSupportLink')}`}
        />
        <MissingPrerequisiteStepActionPicker resource={resource} onClick={() => handleContinueToSecuritySettings()} />
      </FDDialogActions>
    </>
  );
}

MissingPrerequisiteLayout.propTypes = {
};

MissingPrerequisiteLayout.defaultProps = {
};

export default MissingPrerequisiteLayout;
